"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const react_1 = __importDefault(require("react"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
require("./index.scss");
const DeleteDraftModal = (props) => (react_1.default.createElement(ModalPortal_1.default, { isOpen: props.open, onClose: props.closeModal },
    react_1.default.createElement(Popup_1.default, { onClose: props.closeModal, className: 'delete-modal' },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: `Are you sure you want to delete ${props.individual ? 'this draft' : 'all of your drafts'}?`, cancelButtonText: 'No', confirmButtonText: 'Yes, I want to delete', disabled: props.disabled, onConfirm: props.handleDeleteDraft, onCancel: props.closeModal }, props.individual ? (react_1.default.createElement("p", null,
            "You will lose all information in ",
            react_1.default.createElement("b", null,
                "\"",
                props.title,
                "\""),
            " and will not be able to recover this draft.")) : (react_1.default.createElement("p", null, "You will not be able to recover these drafts and will lose any associated information."))))));
exports.default = DeleteDraftModal;
